import { render, staticRenderFns } from "./NotificationPharmacyGroupsApprovalRequestForm.vue?vue&type=template&id=3a657fb7"
import script from "./NotificationPharmacyGroupsApprovalRequestForm.vue?vue&type=script&lang=js"
export * from "./NotificationPharmacyGroupsApprovalRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports